module.exports = __webpack_public_path__ + "static/Ninti-One-Logo-2019-300x156-eec962e9d8e1f1cce446ca255d9c8297.png";